import { PrimaryRegularButton } from 'components/ReusableComponents/Button/RegularButtons'
import { PrimarySmallButton } from 'components/ReusableComponents/Button/SmallButtons'
import Datepicker from 'components/ReusableComponents/Datepicker'
import CustomHeader from 'components/ReusableComponents/HeaderTitles'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import Toggle from 'components/ReusableComponents/Toggle/index'
import { messagingKindsToPaths } from 'features/Messaging/messaging-helpers'
import useCopyText from 'hooks/useCopyText'
import useLocalStorage from 'hooks/useLocalStorageState'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import dashboardApi from 'services/api/dashboard'

import styles from './DailyConversations.module.scss'

function getShortDate(date) {
  return date.toISOString().split('T')[0]
}

const DailyConversations = () => {
  const [conversations, setConversations] = useState()
  const [activeChatId, setActiveChatId] = useState()
  const [date, setDate] = useState(new Date(Date.now() - 86400000))
  const [justShowFlagged, setJustShowFlagged] = useState(false)

  function addToSpamList(message) {
    const localStorageKey = 'dailyConversationsSpamList'

    let currentList = []

    if (localStorage.getItem(localStorageKey)) {
      currentList = JSON.parse(localStorage.getItem(localStorageKey))
    }

    localStorage.setItem(localStorageKey, JSON.stringify([...currentList, message]))
  }

  const copy = useCopyText()

  useEffect(() => {
    setActiveChatId(null)
    setConversations(null)
    dashboardApi.getDailyConversations(date.toISOString()).then(c => {
      setConversations(c)
    })
  }, [date])

  const [reviewedConversations, setReviewedConversations] = useLocalStorage(
    'reviewedConversations',
    {}
  )

  const [flaggedConversations, setFlaggedConversations] = useLocalStorage(
    'flaggedConversations',
    {}
  )

  if (!conversations) return <LoadingIndicator />

  const activeChat = conversations.find(c => c.chatId === activeChatId)

  function handleChatRowClick(chatId) {
    setActiveChatId(chatId)
    setReviewedConversations({
      ...reviewedConversations,
      [getShortDate(date)]: {
        ...reviewedConversations[getShortDate(date)],
        [chatId]: true
      }
    })
  }

  return (
    <div className={styles.wrapper}>
      <CustomHeader title="Daily conversations" isFixed width={1100}>
        <Datepicker onChange={setDate} selected={date} maxDate={new Date() - 1} />
        <Toggle
          mini={true}
          label="Just flagged"
          handleChange={e => setJustShowFlagged(e.target.checked)}
          checked={justShowFlagged}
        />
      </CustomHeader>
      <div className={styles.sidebar}>
        {conversations
          .filter(c =>
            justShowFlagged
              ? flaggedConversations?.[getShortDate(date)]?.[c.chatId]
                ? true
                : false
              : true
          )

          .map(c => (
            <div
              key={c.chatId}
              onClick={() => handleChatRowClick(c.chatId)}
              className={styles.chatRow}
              style={{
                opacity: reviewedConversations?.[getShortDate(date)]?.[c.chatId]
                  ? 0.5
                  : 1,
                background: flaggedConversations?.[getShortDate(date)]?.[c.chatId]
                  ? 'rgba(33, 150, 243, 0.2)'
                  : 'white',
                border: c.chatId === activeChatId ? '1px solid blue' : '1px solid white'
              }}
            >
              <div className={styles.hotelName}>
                {flaggedConversations?.[getShortDate(date)]?.[c.chatId] ? (
                  <span className={styles.flag}>&#9872;</span>
                ) : null}

                {c.hotelName}
              </div>
              <div className={styles.intent}>{c.botContext}</div>
            </div>
          ))}
      </div>
      {activeChatId && (
        <div className={styles.chat}>
          <div className={styles.chatHeader}>
            <Toggle
              label="Reviewed"
              checked={reviewedConversations?.[getShortDate(date)]?.[activeChatId]}
              handleChange={e =>
                setReviewedConversations({
                  ...reviewedConversations,
                  [getShortDate(date)]: {
                    ...reviewedConversations[getShortDate(date)],
                    [activeChatId]: e.target.checked
                  }
                })
              }
            />
            <Toggle
              label="Flagged"
              checked={flaggedConversations?.[getShortDate(date)]?.[activeChatId]}
              handleChange={e =>
                setFlaggedConversations({
                  ...flaggedConversations,
                  [getShortDate(date)]: {
                    ...flaggedConversations[getShortDate(date)],
                    [activeChatId]: e.target.checked
                  }
                })
              }
            />
            <Link
              to={`/s/${activeChat.subsidiaryId}/${
                messagingKindsToPaths[activeChat.kind]
              }/${activeChat.chatId}`}
              className={styles.goToChatButton}
            >
              <PrimaryRegularButton>Go to chat</PrimaryRegularButton>
            </Link>
          </div>
          <div className={styles.bubbles}>
            {activeChat.messages.map(m => (
              <>
                <div className={styles.bubbleHolder}>
                  <div
                    className={
                      m.isSenderClient ? styles.clientBubble : styles.agentBubble
                    }
                    onClick={() => copy(m.content)}
                    key={m.chatId}
                  >
                    {m.content}
                  </div>
                  {m.isSenderClient && (
                    <PrimarySmallButton
                      className={styles.spamButton}
                      onClick={() => addToSpamList(m.content)}
                    >
                      Mark as spam
                    </PrimarySmallButton>
                  )}
                </div>
                {(m.botIntent || m.botContext) && (
                  <div className={styles.details}>
                    {m.botIntent && (
                      <div className={styles.detail}>Intent: {m.botIntent}</div>
                    )}
                    {m.botContext && (
                      <div className={styles.detail}>Action: {m.botContext}</div>
                    )}
                  </div>
                )}
              </>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default DailyConversations
